import React from 'react';
import { string, shape, func, bool } from 'prop-types';

import Forms from 'components/form-react-elements';
import Icon from 'components/icon';

const Search = ({
    isLoading,
    isSearchLoaderVisible,
    searchButtonLabel,
    searchField,
    searchValue,
    handleSubmit,
    onSearchInputChange
}) => {
    const handleSearchInputChange = event => {
        onSearchInputChange(event.target.value);
    };
    if (!searchField) {
        return null;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Forms.Input
                append={
                    <button
                        className={`button button--primary listing-search-button ${
                            isSearchLoaderVisible ? 'is-transparent' : ''
                        }`}
                        disabled={isLoading || isSearchLoaderVisible}
                        type="submit"
                    >
                        {searchButtonLabel && (
                            <span className="listing-search-button__text">
                                {searchButtonLabel}
                            </span>
                        )}

                        <Icon glyph="search" />
                        <span
                            className={`dot-flashing ${
                                isSearchLoaderVisible ? 'is-visible' : ''
                            }`}
                        />
                    </button>
                }
                className="listing-search-input"
                disabled={isLoading}
                label={searchField.label}
                maxLength={searchField.maxLength}
                name={searchField.id}
                placeholder={searchField.placeholder}
                value={searchValue}
                onChange={handleSearchInputChange}
                type="text"
                labelIsHidden
            />
        </form>
    );
};

Search.propTypes = {
    isLoading: bool,
    isSearchLoaderVisible: bool,
    searchButtonLabel: string.isRequired,
    searchField: shape({
        id: string,
        label: string,
        placeholder: string,
        value: string
    }).isRequired,
    searchValue: string.isRequired,
    onSearchInputChange: func.isRequired,
    handleSubmit: func.isRequired
};

export default Search;
